"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const react_loops_1 = require("react-loops");
const index_1 = require("./Field/index");
const constants_1 = require("../../../constants");
exports.ConversionStepCanvasBody = ({ fields }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ConversionStepCanvasBody", flexRowFilled: true },
        react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ConversionStepCanvasBody.fields", flexColCenteredFilled: true },
            react_1.default.createElement(react_loops_1.For, { of: fields }, (field, meta) => {
                const fieldMeta = constants_1.CONVERSION_STEP_FIELD_META[field];
                return (react_1.default.createElement(index_1.ConversionStepCanvasField, Object.assign({ fieldId: field }, fieldMeta, meta)));
            }))));
};
//# sourceMappingURL=index.js.map